import { setNavigationBar } from '@docs/common'
import { useEffect, useMemo, useState } from 'react'

import { useTranslation } from '@volcengine/i18n'
import { Swiper } from 'antd-mobile'
import classNames from 'classnames'

import Installation1 from 'assets/images/bh3/installation_1.png'
import Installation2 from 'assets/images/bh3/installation_2.png'
import Installation3 from 'assets/images/bh3/installation_3.png'
import Installation4 from 'assets/images/bh3/installation_4.png'

import useLanguageTrans from 'common/useLanguageTrans'
import styles from './index.module.scss'

const STEPS = [
  {
    banner: Installation1,
    describe: 'Power off the HomeBase',
  },
  {
    banner: Installation2,
    describe: 'Pull down on the lid to remove it',
  },
  {
    banner: Installation3,
    describe: 'Pull out the hard drive bracket, and then secure your hard drive with screws to it.',
  },
  {
    banner: Installation4,
    describe: 'Insert and screw the bracket back into HomeBase 3, then snap the lid back into place.',
  },
]

const Installation = () => {
  const [swiperIndex, setSwiperIndex] = useState(0)
  const [swiperHeight, setSwiperHeight] = useState(200);
  const swiperDoc = document.querySelector('img');
  useLanguageTrans()
  const { t } = useTranslation()

  const steps = useMemo(() => {
    const value = t('h5_storage_edu_install_steps', {
      defaultValue:
        'Step 1: Power off your HomeBase. \nStep 2: Pull down on the lid to remove it. \nStep 3: Pull out the storage drive bracket, and then secure your storage drive to it with screws. \nStep 4: Insert and screw the bracket back into HomeBase 3, then snap the lid back into place.',
    })
    return value.split(/\n|\\n|\n\n/)
  }, [t])

  console.log({ steps })

  useEffect(() => {
    setNavigationBar({
      title: t('h5_storage_edu_install', { defaultValue: 'Storage Drive Installation' }),
    })
  })

// 使用useEffect监听Swiper高度的变化，并根据需要更新margin-top的值
useEffect(() => {
  const handleResize = () => {
    const clientWidth = Math.min(document.documentElement.clientWidth || 600, 600);
    const height = clientWidth / ( 345 / 194)
    console.log( { clientWidth, height } );
    setSwiperHeight(height);
  };

  // 监听窗口大小变化
  window.addEventListener('resize', handleResize);

  // 初始化时获取Swiper的高度
  handleResize();

  // 清除监听
  return () => {
    window.removeEventListener('resize', handleResize);
  };
}, [swiperDoc?.clientHeight, swiperIndex]);

// 根据Swiper的高度动态计算margin-top的值
  const top = swiperHeight > 0 ? swiperHeight + 'px' : '0';
  
  return (
    <div className={styles.Installation}>
      <div className={styles.InstallationSteps} style={{top}}>
        {steps.map((step, i) => (
          <div className={classNames(styles.StepsCell, { [styles.StepActive]: i === swiperIndex })}>
            <span>{i + 1}</span>
            <p>{step}</p>
          </div>
        ))}
      </div>
      <Swiper
        indicator={(total: number, current: number) => (
          <div className={styles.Indicator}>
            {Array(total)
              .fill(null)
              .map((_, i) => (
                <i className={current === i ? styles.IndicatorActive : ''}></i>
              ))}
          </div>
        )}
        onIndexChange={setSwiperIndex}
      >
        {STEPS.map(step => (
          <Swiper.Item>
            <div className={styles.InstallationWraper}>
              <img src={step.banner} alt="banner" />
            </div>
          </Swiper.Item>
        ))}
      </Swiper>


    </div>
  )
}

export default Installation
